import axios, { AxiosRequestConfig } from 'axios';
import { dispatch } from 'store';
import { openSnackbar } from 'store/reducers/snackbar';

// Allow runtime override via a global injected object (window.__ENV__).
// This lets the container inject env values at runtime (e.g. by serving a small script
// that reads .env and assigns window.__ENV__), falling back to Vite build-time env.
declare global {
  interface Window {
    __ENV__?: Record<string, string>;
  }
}

const runtimeUrl = typeof window !== 'undefined' ? window.__ENV__?.VITE_APP_API_URL : undefined;
const buildTimeUrl = import.meta.env.VITE_APP_API_URL;
const baseUrl = runtimeUrl || buildTimeUrl || 'https://assessorapi.sapphiresolutions.in.net/api/';

const axiosServices = axios.create({ baseURL: baseUrl });

// ==============================|| AXIOS - FOR MOCK SERVICES ||============================== //

axiosServices.interceptors.request.use(
  async (config) => {
    const accessToken = localStorage.getItem('serviceToken');
    if (accessToken) {
      config.headers['authToken'] = `${accessToken}`;
      // use the simple acccess token isnted, remove the Bearer and use just the AuthToken
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosServices.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    if (status === 401 && !window.location.href.includes('/login')) {
      redirectWithBasePath('/login');
    } else {
      const message = error?.response?.data?.message || error?.message || 'Something went wrong';
      dispatch(openSnackbar({ open: true, message, variant: 'alert', alert: { color: 'error' }, close: true }));
    }
    return Promise.reject(error);
  }
);

export default axiosServices;

export const fetcher = async (args: string | [string, AxiosRequestConfig]) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosServices.get(url, { ...config });

  return res.data;
};

export const fetcherPost = async (args: string | [string, AxiosRequestConfig]) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosServices.post(url, { ...config });

  return res.data;
};

export function redirectWithBasePath(path: string) {
  // Redirect directly to the given path without adding any base path.
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  window.location.pathname = normalizedPath;
}
